export default [
  {
    value: 'AF',
    label: 'Afeganistão',
  },
  {
    value: 'AL',
    label: 'Albânia',
  },
  {
    value: 'DZ',
    label: 'Argélia',
  },
  {
    value: 'AS',
    label: 'Samoa Americana',
  },
  {
    value: 'AD',
    label: 'Andorra',
  },
  {
    value: 'AO',
    label: 'Angola',
  },
  {
    value: 'AI',
    label: 'Anguilla',
  },
  {
    value: 'AG',
    label: 'Antígua e Barbuda',
  },
  {
    value: 'AR',
    label: 'Argentina',
  },
  {
    value: 'AM',
    label: 'Armênia',
  },
  {
    value: 'AW',
    label: 'Aruba',
  },
  {
    value: 'AU',
    label: 'Austrália',
  },
  {
    value: 'AT',
    label: 'Áustria',
  },
  {
    value: 'AZ',
    label: 'Azerbaijão',
  },
  {
    value: 'BS',
    label: 'Bahamas',
  },
  {
    value: 'BH',
    label: 'Bahrein',
  },
  {
    value: 'BD',
    label: 'Bangladesh',
  },
  {
    value: 'BB',
    label: 'Barbados',
  },
  {
    value: 'BY',
    label: 'Bielorrússia',
  },
  {
    value: 'BE',
    label: 'Bélgica',
  },
  {
    value: 'BZ',
    label: 'Belize',
  },
  {
    value: 'BJ',
    label: 'Benin',
  },
  {
    value: 'BM',
    label: 'Bermudas',
  },
  {
    value: 'BT',
    label: 'Butão',
  },
  {
    value: 'BO',
    label: 'Bolívia',
  },
  {
    value: 'BA',
    label: 'Bósnia e Herzegovina',
  },
  {
    value: 'BW',
    label: 'Botswana',
  },
  {
    value: 'BR',
    label: 'Brasil',
  },
  {
    value: 'IO',
    label: 'Ilhas Virgens Britânicas',
  },
  {
    value: 'BN',
    label: 'Brunei Darussalam',
  },
  {
    value: 'BG',
    label: 'Bulgária',
  },
  {
    value: 'BF',
    label: 'Burkina Faso',
  },
  {
    value: 'BI',
    label: 'Burundi',
  },
  {
    value: 'CV',
    label: 'Cabo Verde',
  },
  {
    value: 'KH',
    label: 'Camboja',
  },
  {
    value: 'CM',
    label: 'Camarões',
  },
  {
    value: 'CA',
    label: 'Canadá',
  },
  {
    value: 'KY',
    label: 'Ilhas Cayman',
  },
  {
    value: 'CF',
    label: 'República da África Central',
  },
  {
    value: 'TD',
    label: 'Chade',
  },
  {
    value: 'CL',
    label: 'Chile',
  },
  {
    value: 'CN',
    label: 'China',
  },
  {
    value: 'CO',
    label: 'Colômbia',
  },
  {
    value: 'KM',
    label: 'Comores',
  },
  {
    value: 'CG',
    label: 'Congo',
  },
  {
    value: 'CK',
    label: 'Ilhas Cook',
  },
  {
    value: 'CR',
    label: 'Costa Rica',
  },
  {
    value: 'CI',
    label: "Côte D'ivoire",
  },
  {
    value: 'HR',
    label: 'Croácia',
  },
  {
    value: 'CU',
    label: 'Cuba',
  },
  {
    value: 'CU',
    label: 'Curaçao',
  },
  {
    value: 'CY',
    label: 'Chipre',
  },
  {
    value: 'CZ',
    label: 'República Checa',
  },
  {
    value: 'CZ',
    label: 'República Popular Democrática da Coreia',
  },
  {
    value: 'CD',
    label: 'República Democrática do Congo',
  },
  {
    value: 'DK',
    label: 'Dinamarca',
  },
  {
    value: 'DK',
    label: 'Diego Garcia',
  },
  {
    value: 'DJ',
    label: 'Djibuti',
  },
  {
    value: 'DM',
    label: 'Dominica',
  },
  {
    value: 'DO',
    label: 'República Dominicana',
  },
  {
    value: 'EC',
    label: 'Equador',
  },
  {
    value: 'EG',
    label: 'Egito',
  },
  {
    value: 'SV',
    label: 'El Salvador',
  },
  {
    value: 'GQ',
    label: 'Guiné Equatorial',
  },
  {
    value: 'ER',
    label: 'Eritreia',
  },
  {
    value: 'EE',
    label: 'Estônia',
  },
  {
    value: 'EE',
    label: 'Eswatini',
  },
  {
    value: 'ET',
    label: 'Etiópia',
  },
  {
    value: 'FK',
    label: 'Ilhas das Malvinas',
  },
  {
    value: 'FO',
    label: 'ilhas Faroe',
  },
  {
    value: 'FJ',
    label: 'Fiji',
  },
  {
    value: 'FI',
    label: 'Finlândia',
  },
  {
    value: 'FR',
    label: 'França',
  },
  {
    value: 'FR',
    label: 'Departamentos e territórios franceses no Oceano Índico',
  },
  {
    value: 'GF',
    label: 'Guiana Francesa',
  },
  {
    value: 'PF',
    label: 'Polinésia Francesa',
  },
  {
    value: 'GA',
    label: 'Gabão',
  },
  {
    value: 'GM',
    label: 'Gâmbia',
  },
  {
    value: 'GE',
    label: 'Geórgia',
  },
  {
    value: 'DE',
    label: 'Alemanha',
  },
  {
    value: 'GH',
    label: 'Gana',
  },
  {
    value: 'GI',
    label: 'Gibraltar',
  },
  {
    value: 'GR',
    label: 'Grécia',
  },
  {
    value: 'GL',
    label: 'Groenlândia',
  },
  {
    value: 'GD',
    label: 'Granada',
  },
  {
    value: 'GP',
    label: 'Guadalupe',
  },
  {
    value: 'GU',
    label: 'Guam',
  },
  {
    value: 'GT',
    label: 'Guatemala',
  },
  {
    value: 'GG',
    label: 'Guiné',
  },
  {
    value: 'GN',
    label: 'Guiné-bissau',
  },
  {
    value: 'GY',
    label: 'Guiana',
  },
  {
    value: 'HT',
    label: 'Haiti',
  },
  {
    value: 'HN',
    label: 'Honduras',
  },
  {
    value: 'HK',
    label: 'Hong Kong',
  },
  {
    value: 'HU',
    label: 'Hungria',
  },
  {
    value: 'IS',
    label: 'Islândia',
  },
  {
    value: 'IN',
    label: 'Índia',
  },
  {
    value: 'ID',
    label: 'Indonésia',
  },
  {
    value: 'IR',
    label: 'Irã',
  },
  {
    value: 'IQ',
    label: 'Iraque',
  },
  {
    value: 'IE',
    label: 'Irlanda',
  },
  {
    value: 'IL',
    label: 'Israel',
  },
  {
    value: 'IT',
    label: 'Itália',
  },
  {
    value: 'JM',
    label: 'Jamaica',
  },
  {
    value: 'JP',
    label: 'Japão',
  },
  {
    value: 'JO',
    label: 'Jordânia',
  },
  {
    value: 'KZ',
    label: 'Cazaquistão',
  },
  {
    value: 'KE',
    label: 'Quênia',
  },
  {
    value: 'KI',
    label: 'Kiribati',
  },
  {
    value: 'KR',
    label: 'Coréia',
  },
  {
    value: 'XK',
    label: 'Kosovo',
  },
  {
    value: 'KW',
    label: 'Kuwait',
  },
  {
    value: 'KG',
    label: 'Quirguistão',
  },
  {
    value: 'LA',
    label: 'República Democrática Popular do Laos',
  },
  {
    value: 'LV',
    label: 'Letônia',
  },
  {
    value: 'LB',
    label: 'Líbano',
  },
  {
    value: 'LS',
    label: 'Lesoto',
  },
  {
    value: 'LR',
    label: 'Libéria',
  },
  {
    value: 'LY',
    label: 'Líbia',
  },
  {
    value: 'LI',
    label: 'Liechtenstein',
  },
  {
    value: 'LT',
    label: 'Lituânia',
  },
  {
    value: 'LU',
    label: 'Luxemburgo',
  },
  {
    value: 'MO',
    label: 'Macau',
  },
  {
    value: 'MG',
    label: 'Madagáscar',
  },
  {
    value: 'MW',
    label: 'Malawi',
  },
  {
    value: 'MY',
    label: 'Malásia',
  },
  {
    value: 'MV',
    label: 'Maldivas',
  },
  {
    value: 'ML',
    label: 'Mali',
  },
  {
    value: 'MT',
    label: 'Malta',
  },
  {
    value: 'MH',
    label: 'Ilhas Marshall',
  },
  {
    value: 'MQ',
    label: 'Martinica',
  },
  {
    value: 'MR',
    label: 'Mauritânia',
  },
  {
    value: 'MU',
    label: 'Maurício',
  },
  {
    value: 'MX',
    label: 'México',
  },
  {
    value: 'FM',
    label: 'Micronésia',
  },
  {
    value: 'MD',
    label: 'Moldávia',
  },
  {
    value: 'MC',
    label: 'Mônaco',
  },
  {
    value: 'MN',
    label: 'Mongólia',
  },
  {
    value: 'ME',
    label: 'Montenegro',
  },
  {
    value: 'MS',
    label: 'Montserrat',
  },
  {
    value: 'MA',
    label: 'Marrocos',
  },
  {
    value: 'MZ',
    label: 'Moçambique',
  },
  {
    value: 'MM',
    label: 'Mianmar',
  },
  {
    value: 'NA',
    label: 'Namíbia',
  },
  {
    value: 'NR',
    label: 'Nauru',
  },
  {
    value: 'NP',
    label: 'Nepal',
  },
  {
    value: 'NL',
    label: 'Holanda',
  },
  {
    value: 'NC',
    label: 'Nova Caledônia',
  },
  {
    value: 'NZ',
    label: 'Nova Zelândia',
  },
  {
    value: 'NI',
    label: 'Nicarágua',
  },
  {
    value: 'NE',
    label: 'Níger',
  },
  {
    value: 'NG',
    label: 'Nigéria',
  },
  {
    value: 'NU',
    label: 'Niue',
  },
  {
    value: 'NF',
    label: 'Ilha de Norfolk',
  },
  {
    value: 'NF',
    label: 'Macedônia do Norte',
  },
  {
    value: 'MP',
    label: 'Ilhas do norte da Mariana',
  },
  {
    value: 'NO',
    label: 'Noruega',
  },
  {
    value: 'OM',
    label: 'Omã',
  },
  {
    value: 'PK',
    label: 'Paquistão',
  },
  {
    value: 'PW',
    label: 'Palau',
  },
  {
    value: 'PA',
    label: 'Panamá',
  },
  {
    value: 'PG',
    label: 'Papua Nova Guiné',
  },
  {
    value: 'PY',
    label: 'Paraguai',
  },
  {
    value: 'PE',
    label: 'Peru',
  },
  {
    value: 'PH',
    label: 'Filipinas',
  },
  {
    value: 'PL',
    label: 'Polônia',
  },
  {
    value: 'PT',
    label: 'Portugal',
  },
  {
    value: 'PR',
    label: 'Porto Rico',
  },
  {
    value: 'QA',
    label: 'Catar',
  },
  {
    value: 'RO',
    label: 'Romênia',
  },
  {
    value: 'RU',
    label: 'Federação Russa',
  },
  {
    value: 'RW',
    label: 'Ruanda',
  },
  {
    value: 'SH',
    label: 'Saint Helena, Ascensão e Tristan da Cunha',
  },
  {
    value: 'KN',
    label: 'Saint Kitts e Nevis',
  },
  {
    value: 'LC',
    label: 'Santa Lúcia',
  },
  {
    value: 'PM',
    label: 'São Pierre e Miquelon',
  },
  {
    value: 'VC',
    label: 'São Vicente e Granadinas',
  },
  {
    value: 'WS',
    label: 'Samoa',
  },
  {
    value: 'SM',
    label: 'San Marino',
  },
  {
    value: 'ST',
    label: 'São Tomé e Príncipe',
  },
  {
    value: 'SA',
    label: 'Arábia Saudita',
  },
  {
    value: 'SN',
    label: 'Senegal',
  },
  {
    value: 'RS',
    label: 'Sérvia',
  },
  {
    value: 'SC',
    label: 'Seychelles',
  },
  {
    value: 'SL',
    label: 'Serra Leoa',
  },
  {
    value: 'SG',
    label: 'Cingapura',
  },
  {
    value: 'SG',
    label: 'Sint Maarten',
  },
  {
    value: 'SK',
    label: 'Eslováquia',
  },
  {
    value: 'SI',
    label: 'Eslovênia',
  },
  {
    value: 'SB',
    label: 'Ilhas Salomão',
  },
  {
    value: 'SO',
    label: 'Somália',
  },
  {
    value: 'ZA',
    label: 'África do Sul',
  },
  {
    value: 'SS',
    label: 'Sudão do Sul',
  },
  {
    value: 'ES',
    label: 'Espanha',
  },
  {
    value: 'LK',
    label: 'Sri Lanka',
  },
  {
    value: 'SD',
    label: 'Sudão',
  },
  {
    value: 'SR',
    label: 'Suriname',
  },
  {
    value: 'SE',
    label: 'Suécia',
  },
  {
    value: 'CH',
    label: 'Suíça',
  },
  {
    value: 'SY',
    label: 'República Árabe da Síria',
  },
  {
    value: 'TW',
    label: 'Taiwan',
  },
  {
    value: 'TJ',
    label: 'Tajiquistão',
  },
  {
    value: 'TZ',
    label: 'Tanzânia',
  },
  {
    value: 'TH',
    label: 'Tailândia',
  },
  {
    value: 'TL',
    label: 'Timor-Leste',
  },
  {
    value: 'TG',
    label: 'República do Togo',
  },
  {
    value: 'TK',
    label: 'Tokelau',
  },
  {
    value: 'TO',
    label: 'Tonga',
  },
  {
    value: 'TT',
    label: 'Trinidad e Tobago',
  },
  {
    value: 'TN',
    label: 'Tunísia',
  },
  {
    value: 'TR',
    label: 'República da Turquia',
  },
  {
    value: 'TM',
    label: 'Turquemenistão',
  },
  {
    value: 'TC',
    label: 'turcos e Caicos',
  },
  {
    value: 'TV',
    label: 'Tuvalu',
  },
  {
    value: 'UG',
    label: 'Uganda',
  },
  {
    value: 'UA',
    label: 'Ucrânia',
  },
  {
    value: 'AE',
    label: 'Emirados Árabes Unidos',
  },
  {
    value: 'GB',
    label: 'Reino Unido',
  },
  {
    value: 'US',
    label: 'Estados Unidos',
  },
  {
    value: 'US',
    label: 'Ilhas Virgens dos Estados Unidos',
  },
  {
    value: 'UY',
    label: 'Uruguai',
  },
  {
    value: 'UZ',
    label: 'Uzbequistão',
  },
  {
    value: 'VU',
    label: 'Vanuatu',
  },
  {
    value: 'VE',
    label: 'Venezuela',
  },
  {
    value: 'VN',
    label: 'Vietnã',
  },
  {
    value: 'WF',
    label: 'Wallis e Futuna',
  },
  {
    value: 'YE',
    label: 'Iémen',
  },
  {
    value: 'ZM',
    label: 'Zâmbia',
  },
  {
    value: 'ZM',
    label: 'Zimbábue',
  },
];
